import { render, staticRenderFns } from "./AvatarEDU.vue?vue&type=template&id=6bfcb54a&"
import script from "./AvatarEDU.vue?vue&type=script&lang=js&"
export * from "./AvatarEDU.vue?vue&type=script&lang=js&"
import style0 from "./AvatarEDU.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports